import i18n from './i18n';
import utils from './utils';
import zoom from './zoom';
import wordsfilter from './words-filter';
import eventBus from './events';

export default {
  i18n,
  utils,
  zoom,
  wordsfilter,
  eventBus,
};
